"use strict";
(() => {
  // src/utils.ts
  var VALID_ENVS = ["local", "development", "uat", "beta", "class2"];
  var STORAGE_KEY = "xund_env";
  var stripLocalePrefix = (path) => path.replace(/^\/[a-z]{2}(-[a-z]{2})?(?=\/|$)/i, "") || "/";
  var resolveRedirectBase = (env) => {
    if (env === "local")
      return "http://localhost:3104";
    if (env === "class2")
      return "https://patienthub.xund.solutions";
    return `https://patienthub.${env}.xund.solutions`;
  };
  var extractOrderId = (raw) => {
    if (!raw)
      return null;
    try {
      const storage = JSON.parse(raw);
      const key = Object.keys(storage).find((k) => k.endsWith("-checkout_last_order_id"));
      const value = key ? storage[key] : void 0;
      return typeof value === "string" && value ? value : null;
    } catch (e) {
      return null;
    }
  };
  var buildCheckoutNavigationUrl = (shopUrl2, checkoutPath) => {
    const base = shopUrl2.trim();
    const rest = checkoutPath.trim();
    if (!base || !rest)
      return null;
    return `${base.replace(/\/$/, "")}/${rest.replace(/^\/+/, "")}`;
  };
  var resolveRedirectInstruction = (path, params, redirectBase2, shopUrl2, orderId2) => {
    if (path === "/") {
      if (params.get("oseid"))
        return { action: "noop" };
      const suffix = orderId2 ? "?orderSuccess=true&orderId=" + encodeURIComponent(orderId2) : "?orderSuccess=false";
      return { action: "replace", url: `${redirectBase2}/dashboard${suffix}` };
    }
    if (path === "/cart")
      return { action: "replace", url: `${redirectBase2}/dashboard?orderSuccess=false` };
    if (path === "/redirect") {
      const checkoutPath = params.get("checkoutPath");
      const checkoutUrl = checkoutPath ? buildCheckoutNavigationUrl(shopUrl2, checkoutPath) : null;
      if (checkoutUrl)
        return { action: "navigate", url: checkoutUrl };
      return { action: "replace", url: `${redirectBase2}/dashboard` };
    }
    return { action: "replace", url: `${redirectBase2}/dashboard` };
  };

  // src/theme.ts
  var currentPath = stripLocalePrefix(window.location.pathname);
  var urlParams = new URLSearchParams(window.location.search);
  var envParam = urlParams.get("env");
  if (envParam && VALID_ENVS.includes(envParam)) {
    localStorage.setItem(STORAGE_KEY, envParam);
  }
  var _a;
  var activeEnv = (_a = localStorage.getItem(STORAGE_KEY)) != null ? _a : "class2";
  localStorage.removeItem("xund-patient-platform-env");
  var redirectBase = resolveRedirectBase(activeEnv);
  var orderId = extractOrderId(localStorage.getItem("extensionStorage"));
  if (orderId)
    localStorage.removeItem("extensionStorage");
  var _a2, _b;
  var shopUrl = (_b = (_a2 = document.querySelector('meta[name="x-shop-url"]')) == null ? void 0 : _a2.content) != null ? _b : "";
  var instruction = resolveRedirectInstruction(currentPath, urlParams, redirectBase, shopUrl, orderId);
  if (instruction.action === "replace") {
    window.location.replace(instruction.url);
  } else if (instruction.action === "navigate") {
    window.location.href = instruction.url;
  }
})();
